import {
  Button,
  DateInput,
  Edit,
  Label,
  LightBulb,
  PlusIcon,
  SalaryTextInput,
  SingleSelectDropdown,
  UploadResume,
} from "@monsterindia/global-ui-components";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";

import { API_ENDPOINT } from "../../../constants/appConstant";
import {
  NoticePeriodDropdownOptionsList,
  SalaryModeOptions,
} from "../../../constants/employment";
import { convertStartAndEndDateToYearsAndMonth } from "../../../helpers/convertDateToYearsAndMonth";
import {
  getNoticePeriodFromDays,
  getNoticePeriodToDays,
} from "../../../helpers/getNoticePeriod";
import { getSalaryBasedOnSiteContext } from "../../../helpers/getSalaryBasedOnSiteContext";
import { shouldShowSalaryNudge } from "../../../helpers/shouldShowSalaryNudge";
import { useNetwork } from "../../../hooks/useNetwork";
import { ApopProps, CheckboxOptionType } from "../../../types";
import { KeyValueType } from "../../../types/common";
import { getSiteProps } from "../../../utils/siteProps";
import { ActionButtonContainer } from "../common/ActionButtonContainer";
import { ApplyForJobCard } from "../common/ApplyForJobCard";
import { Heading } from "../common/Heading";
import { LinkedInConsent } from "../common/Linkedin/LinkedinConsent";
import { Events } from "../common/json/clevertapEvents";
import { CurrentEmploymentDetailsWrapper } from "./CurrentEmploymentDetail";

interface UpdatedData {
  [key: string]: any;
}

export const ResumeEmploymentApop = ({
  prefilledData,
  nextApopType,
  onCTA,
  toast,
  closeApop,
  flowType,
  jobData,
  eventName,
  handleEventTracking,
}: ApopProps) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
    setError,
    getValues,
    clearErrors,
  } = useForm();

  const [showCurrentEmploymentDetails, setShowCurrentEmploymentDetails] =
    useState(false);
  const [isExperienced, setIsExperienced] = useState(false);
  // const [showLinkedinConsent, setShowLinkedinConsent] = useState(true);
  const [isAutoUpdateChecked, setIsAutoUpdateChecked] = useState(false);
  const [isResumeUploaded, setIsResumeUploaded] = useState(true);
  const [isServingNotice, setIsServingNotice] = useState(false);
  const [isCurrentlyWorking, setIsCurrentlyWorking] = useState(true);

  const { response: apiResponse, fetchData: submitFetchApi } = useNetwork();

  const siteConfig = getSiteProps(window.location.hostname);

  const defaultCurrencySelected = {
    value: siteConfig?.currency_name,
    id: siteConfig?.currency_id,
    text: siteConfig?.currency_code,
  };

  const salaryMode =
    siteConfig?.site_map === "rexmonster"
      ? SalaryModeOptions[1]
      : SalaryModeOptions[0];

  const updatedSalary = getSalaryBasedOnSiteContext({
    absoluteSalary: (prefilledData?.employmentPrefill as any)?.salary
      ?.absoluteValue
      ? ((prefilledData?.employmentPrefill as any)?.salary
          ?.absoluteValue as number)
      : 0,
    siteContext: siteConfig?.site_map ?? "rexmonster",
    salaryMode: (prefilledData?.employmentPrefill as any)?.salary?.salaryMode
      ?.id
      ? (prefilledData?.employmentPrefill as any)?.salary?.salaryMode
      : salaryMode,
  });

  const showCurrentEmploymentDetailsHandler = (value: boolean) => {
    setShowCurrentEmploymentDetails(value);
    if (!value) {
      setTimeout(() => {
        document.body.classList.add("overflow_hidden");
      }, 0);
    }
  };

  const prefillDataHelper = async (prefillData: any) => {
    const { resumePrefill, employmentPrefill, linkedInResponse } = prefillData;

    if (resumePrefill && resumePrefill?.fileName) {
      setIsResumeUploaded(true);
    } else {
      setIsResumeUploaded(false);
    }

    if (employmentPrefill && Object.keys(employmentPrefill).length > 0) {
      setIsExperienced(true);
    } else {
      setIsExperienced(false);
    }

    if (employmentPrefill) {
      const { salary, noticePeriod } = employmentPrefill;

      const currentCompanyName =
        employmentPrefill && (employmentPrefill as any)?.company
          ? (employmentPrefill as any)?.company.text
          : "";

      setValue("currentCompanyName", currentCompanyName);

      const currentDesignation =
        employmentPrefill && (employmentPrefill as any)?.designation
          ? (employmentPrefill as any)?.designation.text
          : "";

      setValue("currentDesignation", currentDesignation);

      const currentStartDate =
        employmentPrefill && (employmentPrefill as any)?.startDate
          ? (employmentPrefill as any)?.startDate
          : "";

      setValue("currentStartDate", currentStartDate);

      const currentEndDate =
        employmentPrefill && (employmentPrefill as any)?.endDate
          ? (employmentPrefill as any)?.endDate
          : "";

      setValue("currentEndDate", currentEndDate);
      if (currentEndDate) {
        setIsCurrentlyWorking(false);
      } else {
        setIsCurrentlyWorking(true);
      }

      if (salary) {
        if (salary?.absoluteValue) {
          setValue("salary", updatedSalary.toString());
        }
        setValue("currency", {
          value: salary?.currency,
          text: salary?.currency,
        });
      } else {
        setValue("currency", defaultCurrencySelected);
      }

      if (noticePeriod && !currentEndDate) {
        if (noticePeriod?.serving) {
          setIsServingNotice(true);
        }
        if (noticePeriod?.days !== undefined) {
          setValue("notice", {
            value: noticePeriod?.days,
            text: NoticePeriodDropdownOptionsList.find((notice) => {
              const noticePeriodInText = getNoticePeriodFromDays(
                noticePeriod?.days,
                noticePeriod?.serving,
              );
              return notice.text === noticePeriodInText;
            })?.text,
          });
        }
        if (noticePeriod?.lastWorkingDay) {
          setValue("lastWorkingDate", noticePeriod?.lastWorkingDay);
        }
      }
    }

    // if (linkedInResponse) {
    // const { linkedInConsent } = linkedInResponse;
    // if (linkedInConsent === false || linkedInConsent === true) {
    //   setValue("isToggled", linkedInConsent);
    //   setShowLinkedinConsent(false);
    // } else {
    //   setShowLinkedinConsent(true);
    //   setValue("isToggled", true);
    //   setIsAutoUpdateChecked(true);
    // }
    // } else {
    // setShowLinkedinConsent(true);
    // setValue("isToggled", true);
    // setIsAutoUpdateChecked(true);
    // }
  };

  useEffect(() => {
    if (prefilledData) {
      prefillDataHelper(prefilledData);
    }
  }, [prefilledData]);

  const onFileUpload = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    const res = await submitFetchApi(
      `${API_ENDPOINT().seekerProfile.attachResume}?saveToDB=false&isExperienced=${
        isExperienced
      }`,
      "PUT",
      {},
      formData,
      true,
    );

    if (res.data) {
      setIsResumeUploaded(true);
      handleEventTracking({
        eventType: "eventPush",
        eventName: Events["RESUMEANDEMPLOYMENT"]?.resumeUpload?.["EVENTNAME"],
        eventProps: Events["RESUMEANDEMPLOYMENT"]?.resumeUpload?.["EVENTOBJ"],
      });
      toast &&
        toast({
          showToast: true,
          text:
            (res.data as any)?.responseData?.response_message ??
            "Updating user resume",
          type: "success",
        });
    } else {
      setIsResumeUploaded(false);
      toast &&
        toast({
          showToast: true,
          text:
            (res.error as any)?.error?.message?.errorMessage ??
            "Something went wrong",
          type: "error",
        });
    }
  };

  const onSubmit = async (data: any) => {
    let updatedData: UpdatedData = {
      profileAutoUpdate: {},
    };

    // If resume is present or uploaded, add resumeDetails key
    // only resumeDetails key is required
    if (prefilledData?.resumePrefill || isResumeUploaded) {
      updatedData = {
        ...updatedData,
        resumeDetails: {},
      };
    }

    if (isExperienced || (prefilledData && prefilledData?.employmentPrefill)) {
      updatedData = {
        ...updatedData,
        employmentDetails: {},
      };
    }

    if (
      prefilledData &&
      prefilledData?.employmentPrefill &&
      typeof prefilledData?.employmentPrefill === "object"
    ) {
      updatedData = {
        ...updatedData,
        employmentDetails: { ...prefilledData.employmentPrefill },
      };
    }
    if (data.salary) {
      if (updatedData["employmentDetails"]["salary"]) {
        updatedData["employmentDetails"]["salary"]["absoluteValue"] =
          data.salary;
      } else {
        updatedData["employmentDetails"]["salary"] = {
          absoluteValue: data.salary,
        };
      }

      if (data.currency) {
        if (updatedData["employmentDetails"]["salary"]) {
          updatedData["employmentDetails"]["salary"]["currency"] =
            data.currency.text;
        } else {
          updatedData["employmentDetails"]["salary"] = {
            currency: data.currency.text,
          };
        }
      }
    }

    if (
      updatedData["employmentDetails"] &&
      updatedData["employmentDetails"]["salary"]
    ) {
      if (updatedData["employmentDetails"]["salary"]["salaryMode"]) {
        updatedData["employmentDetails"]["salary"]["salaryMode"] = {
          id: salaryMode.uuid,
          text: salaryMode.name,
        };
      } else {
        updatedData["employmentDetails"]["salary"] = {
          ...(updatedData["employmentDetails"]["salary"] ?? {}),
          salaryMode: {
            id: salaryMode.uuid,
            text: salaryMode.name,
          },
        };
      }
    }

    if (data.currentEndDate) {
      updatedData["employmentDetails"]["endDate"] = data.currentEndDate;
    }

    if (data.notice) {
      updatedData["employmentDetails"]["noticePeriod"] = {
        days: getNoticePeriodToDays(data.notice.text),
        serving: data.notice.text === "Serving Notice Period" ? true : false,
        lastWorkingDay:
          data.notice.text === "Serving Notice Period" ? data.date : null,
      };

      if (data.lastWorkingDate) {
        updatedData["employmentDetails"]["noticePeriod"]["lastWorkingDay"] =
          data.lastWorkingDate;
      }
    }

    // Remove notice period key if not selected
    if (updatedData["employmentDetails"]) {
      if (
        updatedData["employmentDetails"]["noticePeriod"] &&
        Object.keys(updatedData["employmentDetails"]["noticePeriod"]).length ===
          0
      ) {
        delete updatedData["employmentDetails"]["noticePeriod"];
      }
    }

    if (data.isToggled) {
      updatedData["profileAutoUpdate"]["linkedInConsent"] = data.isToggled;
    } else {
      updatedData["profileAutoUpdate"]["linkedInConsent"] = false;
      updatedData["profileAutoUpdate"]["reason"] = "OTHER_REASONS";
    }

    if (
      updatedData["employmentDetails"] &&
      Object.keys(updatedData["employmentDetails"]).length === 0
    ) {
      updatedData["employmentDetails"] = null;
    }

    // API CALL
    const res = await submitFetchApi(
      API_ENDPOINT().seekerProfile.updateResumeEmployment,
      "POST",
      {},
      updatedData,
    );

    if (res.data) {
      toast &&
        toast({
          showToast: true,
          text: (res.data as any)?.message ?? "Section updated successfully",
          type: "success",
        });

      let shortHand = Events["RESUMEANDEMPLOYMENT"].confirmInfo["EVENTOBJ"];
      shortHand.uploadResume = isResumeUploaded ? "Yes" : "No";
      shortHand.autoUpdate = isAutoUpdateChecked ? "Yes" : "No";
      shortHand.fresher = isExperienced ? "No" : "Yes";
      handleEventTracking({
        eventType: "eventPush",
        eventName: Events["RESUMEANDEMPLOYMENT"]?.confirmInfo?.["EVENTNAME"],
        eventProps: Events["RESUMEANDEMPLOYMENT"]?.confirmInfo?.["EVENTOBJ"],
      });

      const salaryData = updatedData?.employmentDetails?.salary;
      if (
        salaryData &&
        salaryData.absoluteValue &&
        shouldShowSalaryNudge(
          salaryData.absoluteValue,
          siteConfig?.site_map === "rexmonster",
        )
      ) {
        nextApopType("SALARY", {
          actionType: "SALARY",
          nextActionData: (res.data as any)?.nextActionRequired ?? null,
          salaryPrefill: {
            salary: {
              absoluteValue: salaryData.absoluteValue,
              currency: salaryData.currency,
              confidential: salaryData.confidential ?? false,
              salaryMode: {
                uuid: salaryMode.uuid,
                text: salaryMode.name,
              },
            },
          },
        });
      } else {
        setTimeout(() => {
          closeApop();
        }, 2000);
      }
    } else {
      toast &&
        toast({
          showToast: true,
          text:
            (res.error as any)?.error?.message?.errorMessage ??
            "Something went wrong",
          type: "error",
        });
    }
  };

  interface UpdatedPrefilledData {
    actionType: string;
    experienceLevel: string;
    resumePrefill?: any;
    employmentPrefill?: any;
    linkedInResponse: any;
  }

  let updatedPrefilledData: UpdatedPrefilledData = {
    actionType: "EMPLOYMENT",
    experienceLevel: isExperienced ? "EXPERIENCED" : "FRESHER",
    linkedInResponse:
      prefilledData && prefilledData?.linkedInResponse
        ? (prefilledData?.linkedInResponse as any)
        : undefined,
  };

  if (prefilledData && prefilledData?.resumePrefill) {
    updatedPrefilledData = {
      ...updatedPrefilledData,
      resumePrefill: prefilledData?.resumePrefill,
    };
  }

  if (prefilledData && prefilledData?.employmentPrefill) {
    updatedPrefilledData = {
      ...updatedPrefilledData,
      employmentPrefill:
        prefilledData && prefilledData?.employmentPrefill
          ? (prefilledData?.employmentPrefill as any)
          : undefined,
    };
  }

  return (
    <>
      <Heading
        headingText="Job Application"
        isMobile={window.innerWidth < 768}
        onCloseBtnClickHandler={() => {
          closeApop();
        }}
      />

      <div
        className={`l1-relative l1-mb-16 l1-mt-14 l1-flex l1-w-full l1-flex-col l1-gap-4 md:l1-mb-12 md:l1-mt-12 ${showCurrentEmploymentDetails && window.innerWidth > 768 ? "l1-hidden" : ""}`}
        id="resumeUploadDetailsForm"
      >
        {jobData ? (
          <ApplyForJobCard
            jobId={jobData.jobId}
            jobTitle={jobData.jobTitle}
            companyName={jobData.companyName}
            companyLogoUrl={jobData.companyLogoUrl}
          />
        ) : null}
        <div className="l1-flex l1-flex-col l1-gap-3">
          <h2 className="l1-text-base l1-font-bold l1-text-content-primary">
            Recruiter requires following details
          </h2>
          {prefilledData && prefilledData?.resumePrefill ? (
            <UploadResume
              variant="baseWithDND"
              uploadButtonModifier="secondary"
              onFileUpload={onFileUpload}
              fileData={
                prefilledData &&
                prefilledData?.resumePrefill &&
                (prefilledData?.resumePrefill as any)?.fileName
                  ? {
                      name: (prefilledData?.resumePrefill as any)?.fileName,
                      // Remove these fields in guic
                      size: "",
                      type: "",
                    }
                  : null
              }
            />
          ) : null}
        </div>

        <form
          className="l1-flex l1-w-full l1-flex-col l1-gap-4"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          {prefilledData && prefilledData?.employmentPrefill ? (
            <>
              {isExperienced ? (
                <>
                  <div className="l1-relative l1-w-full l1-rounded-lg">
                    <div className="l1-flex l1-items-center l1-gap-1 l1-rounded-t-lg l1-border !l1-border-b-0 l1-border-decorative-surface-03 l1-bg-decorative-surface-03 l1-p-1.5">
                      <LightBulb width={16} height={16} />
                      <p className="l1-text-xs l1-text-decorative-content-03">
                        Get hired faster by sharing latest info
                      </p>
                    </div>
                    <div className="l1-flex l1-flex-col l1-gap-4 l1-rounded-b-lg l1-border !l1-border-t-0 l1-border-border-subtle l1-bg-white l1-p-4">
                      <Label
                        labelText={`Current ${salaryMode.name} Salary`}
                        isRequired={true}
                        className="!l1-text-sm"
                      >
                        <Controller
                          name="salary"
                          control={control}
                          rules={{
                            required: "This field is required",
                            validate: (value) =>
                              (Number(value) && Number(value) > 0) ||
                              "Salary value cannot be 0.",
                          }}
                          render={({ field }) => {
                            return (
                              <SalaryTextInput
                                countryCurrency={
                                  getValues("currency") ??
                                  defaultCurrencySelected
                                }
                                setCountryCurrency={(value: unknown) => {
                                  setValue("currency", value);
                                  clearErrors("currency");
                                  if (
                                    prefilledData &&
                                    prefilledData?.employmentPrefill
                                  ) {
                                    if (
                                      (prefilledData?.employmentPrefill as any)
                                        ?.salary?.currency &&
                                      (prefilledData?.employmentPrefill as any)
                                        ?.salary?.currency !== null
                                    ) {
                                      (
                                        prefilledData.employmentPrefill as any
                                      ).salary.currency = (
                                        value as { text: string }
                                      ).text;
                                    }
                                  }
                                }}
                                absoluteSalary={field.value ?? ""}
                                setAbsoluteSalary={(value: string) => {
                                  setValue("salary", value);
                                  clearErrors("salary");
                                  if (
                                    prefilledData &&
                                    prefilledData?.employmentPrefill
                                  ) {
                                    if (
                                      (prefilledData?.employmentPrefill as any)
                                        ?.salary?.absoluteValue &&
                                      (prefilledData?.employmentPrefill as any)
                                        ?.salary?.absoluteValue !== null
                                    ) {
                                      (
                                        prefilledData.employmentPrefill as any
                                      ).salary.absoluteValue = value;
                                    }
                                  }
                                }}
                                isSalaryAnnual={
                                  siteConfig?.site_map === "rexmonster"
                                }
                                required={true}
                                placeholder={
                                  siteConfig?.site_map === "rexmonster"
                                    ? "Enter Annual Salary"
                                    : "Enter Monthly Salary"
                                }
                                errorText={errors.salary?.message}
                                tooltipText={
                                  siteConfig?.site_map === "rexmonster"
                                    ? "To rank high in recruiter searches, ensure you enter the correct annual salary."
                                    : undefined
                                }
                              />
                            );
                          }}
                        />
                      </Label>

                      {isCurrentlyWorking ? (
                        <>
                          <Label
                            labelText="Notice Period"
                            isRequired={true}
                            className="!l1-text-sm"
                          >
                            <Controller
                              name="notice"
                              control={control}
                              rules={{ required: "This field is required" }}
                              render={({ field }) => {
                                return (
                                  <SingleSelectDropdown
                                    {...field}
                                    id="notice"
                                    width="!l1-w-full"
                                    placeholder="Select Notice Period"
                                    isSearchable={false}
                                    options={NoticePeriodDropdownOptionsList}
                                    selectedValue={field.value ?? null}
                                    handleDropdownSelect={(
                                      value: CheckboxOptionType,
                                    ) => {
                                      if (
                                        value.text === "Serving Notice Period"
                                      ) {
                                        setIsServingNotice(true);
                                      } else {
                                        setIsServingNotice(false);
                                      }
                                      setValue("notice", value);
                                      clearErrors("notice");
                                      if (
                                        prefilledData &&
                                        prefilledData?.employmentPrefill
                                      ) {
                                        if (
                                          (
                                            prefilledData?.employmentPrefill as any
                                          )?.noticePeriod
                                        ) {
                                          (
                                            prefilledData.employmentPrefill as any
                                          ).noticePeriod = {
                                            days: getNoticePeriodToDays(
                                              value.text,
                                            ),
                                            serving:
                                              value.text ===
                                              "Serving Notice Period",
                                            lastWorkingDay: null,
                                          };
                                        } else {
                                          prefilledData.employmentPrefill = {
                                            ...(typeof prefilledData.employmentPrefill ===
                                            "object"
                                              ? prefilledData.employmentPrefill
                                              : {}),
                                            noticePeriod: {
                                              days: getNoticePeriodToDays(
                                                value.text,
                                              ),
                                              serving:
                                                value.text ===
                                                "Serving Notice Period",
                                              lastWorkingDay: null,
                                            },
                                          };
                                        }
                                      }
                                    }}
                                    errorText={
                                      errors.notice
                                        ? "This field is required"
                                        : ""
                                    }
                                  />
                                );
                              }}
                            />
                          </Label>

                          {isServingNotice ? (
                            <Label
                              labelText="Last Working Day"
                              isRequired={true}
                              className="!l1-text-sm"
                            >
                              <Controller
                                name="lastWorkingDate"
                                control={control}
                                rules={{ required: "This field is required" }}
                                render={({ field }) => {
                                  const minDate = new Date()
                                    .toISOString()
                                    .split("T")[0];
                                  return (
                                    <DateInput
                                      value={field.value ?? ""}
                                      placeholder="YYYY/MM/DD"
                                      onDateSelect={(date: string) => {
                                        setValue("lastWorkingDate", date);
                                        clearErrors("lastWorkingDate");
                                        if (
                                          prefilledData &&
                                          prefilledData?.employmentPrefill
                                        ) {
                                          if (
                                            (
                                              prefilledData?.employmentPrefill as any
                                            )?.noticePeriod &&
                                            (
                                              prefilledData?.employmentPrefill as any
                                            )?.noticePeriod?.lastWorkingDay
                                          ) {
                                            (
                                              prefilledData.employmentPrefill as any
                                            ).noticePeriod.lastWorkingDay =
                                              date;
                                          } else {
                                            prefilledData.employmentPrefill = {
                                              ...(typeof prefilledData.employmentPrefill ===
                                              "object"
                                                ? prefilledData.employmentPrefill
                                                : {}),
                                              noticePeriod: {
                                                days: getNoticePeriodToDays(
                                                  getValues("notice").text,
                                                ),
                                                serving: true,
                                                lastWorkingDay: date,
                                              },
                                            };
                                          }
                                        }
                                      }}
                                      min={minDate}
                                      errorText={
                                        errors.lastWorkingDate
                                          ? "This field is required"
                                          : ""
                                      }
                                    />
                                  );
                                }}
                              />
                            </Label>
                          ) : null}
                        </>
                      ) : (
                        <Label
                          labelText="End Date"
                          isRequired={true}
                          className="!l1-text-sm"
                        >
                          <Controller
                            name="currentEndDate"
                            control={control}
                            render={({ field }) => {
                              const minDate = getValues("currentStartDate")
                                ? new Date(getValues("currentStartDate"))
                                    .toISOString()
                                    .split("T")[0]
                                : "";

                              const maxDate = new Date()
                                .toISOString()
                                .split("T")[0];
                              return (
                                <DateInput
                                  value={field.value ?? ""}
                                  placeholder="YYYY/MM/DD"
                                  onDateSelect={(date: string) => {
                                    setValue("currentEndDate", date);
                                    clearErrors("currentEndDate");

                                    if (
                                      prefilledData &&
                                      prefilledData?.employmentPrefill
                                    ) {
                                      if (
                                        (
                                          prefilledData?.employmentPrefill as any
                                        )?.endDate
                                      ) {
                                        (
                                          prefilledData.employmentPrefill as any
                                        ).endDate = date;
                                      } else {
                                        prefilledData.employmentPrefill = {
                                          ...(typeof prefilledData.employmentPrefill ===
                                          "object"
                                            ? prefilledData.employmentPrefill
                                            : {}),
                                          endDate: date,
                                        };
                                      }
                                    }
                                  }}
                                  min={minDate}
                                  max={maxDate}
                                  errorText={
                                    errors.currentEndDate
                                      ? "This field is required"
                                      : ""
                                  }
                                />
                              );
                            }}
                          />
                        </Label>
                      )}
                    </div>
                  </div>

                  <div className="l1-flex l1-flex-col l1-gap-3">
                    <h2 className="l1-text-base l1-font-bold l1-text-content-primary">
                      Current Employment Details
                    </h2>

                    <div className="l1-relative l1-flex l1-w-full l1-flex-col l1-gap-1 l1-rounded-lg l1-border l1-border-border-subtle l1-bg-surface-background l1-p-4">
                      <div className="l1-flex l1-items-center l1-justify-between l1-gap-3">
                        {getValues("currentDesignation") ? (
                          <h4 className="l1-max-w-[90%] l1-break-words l1-text-base l1-font-bold l1-text-content-primary">
                            {getValues("currentDesignation")}
                          </h4>
                        ) : null}

                        <button
                          type="button"
                          className="l1-ml-auto l1-w-max l1-cursor-pointer"
                          onClick={() =>
                            showCurrentEmploymentDetailsHandler(true)
                          }
                        >
                          <Edit width={16} height={16} />
                        </button>
                      </div>
                      {getValues("currentCompanyName") ? (
                        <p className="l1-break-words l1-text-base l1-font-medium l1-text-content-primary">
                          {getValues("currentCompanyName")}
                        </p>
                      ) : null}
                      {getValues("currentStartDate") ? (
                        <p className="l1-text-sm l1-text-content-primary">
                          {convertStartAndEndDateToYearsAndMonth(
                            getValues("currentStartDate"),
                            getValues("currentEndDate"),
                          )}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </>
              ) : (
                <div className="l1-relative l1-flex l1-w-full l1-flex-col l1-gap-4 l1-rounded-lg l1-border l1-border-border-subtle l1-bg-surface-background l1-p-4">
                  <h2 className="l1-text-base l1-font-bold l1-text-content-primary">
                    Not a fresher anymore?
                  </h2>

                  <Button
                    type="button"
                    modifier="tertiary"
                    label="Add Employment"
                    className="!l1-w-max !l1-px-0"
                    leftIcon={
                      <PlusIcon
                        width={16}
                        height={16}
                        className="l1-fill-brand-primary"
                      />
                    }
                    onClick={() => showCurrentEmploymentDetailsHandler(true)}
                  />

                  <Label
                    labelText={`Current ${salaryMode.name} Salary`}
                    isRequired={false}
                    className="!l1-text-sm"
                  >
                    <SalaryTextInput
                      countryCurrency={defaultCurrencySelected}
                      setCountryCurrency={(value: unknown) => {}}
                      absoluteSalary={""}
                      setAbsoluteSalary={(value: string) => {}}
                      disabled={true}
                      placeholder={
                        siteConfig?.site_map === "rexmonster"
                          ? "Enter Annual Salary"
                          : "Enter Monthly Salary"
                      }
                    />
                  </Label>

                  <Label
                    labelText="Notice Period"
                    className="!l1-text-sm"
                    isRequired={false}
                  >
                    <SingleSelectDropdown
                      id="notice"
                      width="!l1-w-full"
                      placeholder="Select Notice Period"
                      isSearchable={false}
                      disabled={true}
                      options={NoticePeriodDropdownOptionsList}
                      selectedValue={null}
                      handleDropdownSelect={(value: CheckboxOptionType) => {}}
                    />
                  </Label>
                </div>
              )}
            </>
          ) : null}

          {/* {showLinkedinConsent ? (
            <LinkedInConsent
              checked={isAutoUpdateChecked}
              handleConsentToggle={(e: React.ChangeEvent<HTMLInputElement>) => {
                setValue("isToggled", e.target.checked);
                setIsAutoUpdateChecked(e.target.checked);
              }}
            />
          ) : null} */}
          <ActionButtonContainer
            primaryBtnLabel="Confirm & Apply"
            isLoading={apiResponse.isLoading}
          />
        </form>
      </div>

      {showCurrentEmploymentDetails ? (
        <CurrentEmploymentDetailsWrapper
          nextApopType={nextApopType}
          toast={toast}
          onCTA={onCTA}
          prefilledData={updatedPrefilledData as unknown as KeyValueType}
          showCurrentEmploymentDetails={showCurrentEmploymentDetails}
          backBtnClickHandler={() => showCurrentEmploymentDetailsHandler(false)}
          closeApop={() => showCurrentEmploymentDetailsHandler(false)}
          flowType={flowType}
          handleEventTracking={handleEventTracking}
        />
      ) : null}
    </>
  );
};
